import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import _map from 'lodash.map'

import Song from './song'
import FailedSearch from './search-failed'
import PageArrow from './page-arrow'

import Loader from '../../styled/loader'
import MetaSelectContainer from '../../styled/meta-select-container'
import SongListContainer, { ListControls } from '../../styled/song-list'
import InputGroup from '../../styled/input-group'
import Select from '../../styled/select'

import { context as SongListContext } from '../../context/song-list'

import { pageView, PAGES } from '../../utils/analytics-tracker'
import windowStorage from '../../utils/window-storage'

import SearchTags from '../tags/search-tags'
import { ADD_FIELDS } from '../setlists/view'

const ComboSelect = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 0px;
  padding: 0px;
`

export default () => {
  const { songs, modifyList, page, tags, filter, count, sortBy, sortOrder, hasMore, loading } = useContext(SongListContext)

  useEffect(() => {
    pageView(PAGES.SONG_LIST_VIEW)
  }, ['-'])

  const [addFieldKey, setAddFieldKey] = useState(windowStorage.getItem('songMetaFieldName') || '')

  const onAddFieldChange = (option) => {
    const value = option ? option.value : ''
    windowStorage.setItem('songMetaFieldName', value)
    setAddFieldKey(value)
  }

  const tagChanged = (which, value) => {
    modifyList('filter', '')
    // clear search text
    modifyList(which, value)
  }

  return (
    <SongListContainer className='App'>
      <div className='songListHeader'>
        <h2>My Songs <Link title='Create a new song' to='/new-song'>+</Link></h2>
        <InputGroup>
          <ListControls>
            <SearchTags noCreate tags={tags} filter={filter} changeFn={tagChanged} />
            <div>
              <label>Sort By</label>
              <ComboSelect>
                <Select
                  value={{ value: sortBy, label: sortBy === 'sortTitle' ? 'Title' : sortBy === 'sortArtist' ? 'Artist' : sortBy === 'lastRehearsed' ? 'Last Rehearsal' : 'Created At' }}
                  onChange={(option) => modifyList('sortBy', option.value)}
                  options={[
                    { value: 'sortTitle', label: 'Title' },
                    { value: 'sortArtist', label: 'Artist' },
                    { value: 'lastRehearsed', label: 'Last Rehearsal' },
                    { value: 'createdAt', label: 'Created At' }
                  ]}
                />
                <Select
                  style={{ width: '45%' }}
                  value={{ value: sortOrder, label: (sortBy === 'sortTitle' || sortBy === 'sortArtist') ? (sortOrder === '1' ? 'A-Z' : 'Z-A') : (sortOrder === '-1' ? 'New' : 'Old') }}
                  onChange={(option) => modifyList('sortOrder', option.value)}
                  options={(sortBy === 'sortTitle' || sortBy === 'sortArtist')
                    ? [{ value: '1', label: 'A-Z' }, { value: '-1', label: 'Z-A' }]
                    : [{ value: '-1', label: 'New' }, { value: '1', label: 'Old' }]}
                />
              </ComboSelect>
            </div>

            <div>
              <label>Display</label>
              <Select
                value={{ value: count, label: count }}
                onChange={(option) => modifyList('count', option.value)}
                options={[
                  { value: '10', label: '10' },
                  { value: '25', label: '25' },
                  { value: '50', label: '50' },
                  { value: '100', label: '100' },
                  { value: '250', label: '250' }
                ]}
              />
            </div>
            <div style={{ display: 'flex' }}>
              <PageArrow direction='left' enabled={page > 1} onClick={() => modifyList('page', page - 1)} />
              <PageArrow direction='right' enabled={songs && hasMore} onClick={() => modifyList('page', page + 1)} />
            </div>
          </ListControls>
        </InputGroup>
        <MetaSelectContainer>
          <label>Metadata:</label>
          <Select
            value={addFieldKey ? ADD_FIELDS.find(field => field.key === addFieldKey) ? { value: addFieldKey, label: ADD_FIELDS.find(field => field.key === addFieldKey).label } : null : null}
            onChange={onAddFieldChange}
            options={ADD_FIELDS.map(addField => ({ value: addField.key, label: addField.label }))}
            placeholder='Select metadata...'
            isClearable
          />
        </MetaSelectContainer>
      </div>
      {(!loading && songs && songs.length > 0) ? _map(songs, song => <Song addFieldKey={addFieldKey} key={song._id} song={song} sortBy={sortBy} />) : !loading && <FailedSearch filter={filter} />}
      {loading && <Loader />}
      <ListControls>
        <PageArrow direction='left' enabled={page > 1} onClick={() => modifyList('page', page - 1)} />
        <Link to='/new-song'>Create Song</Link>
        <PageArrow direction='right' enabled={songs && hasMore} onClick={() => modifyList('page', page + 1)} />
      </ListControls>
    </SongListContainer>
  )
}
